import type { ApolloClient } from "@apollo/client";
import { GQL } from "@binale-tech/shared";

import { dmsDocumentFindDraftsQuery } from "@domain/context/queries/agentQueries.graphql";
import { DmsType } from "@domain/models/dms";

import type { DraftDocument } from "./draftSelection";
import { MAX_IDS_PER_JOB } from "./draftSelection";
import { fetchAllPages } from "./paging";

/** ER, Bank and KB documents of the year with a finished AI read, linked to no record and to no transaction. */
export const findDraftDocuments = async (
    client: Pick<ApolloClient, "query">,
    companyId: string,
    year: number,
): Promise<DraftDocument[]> => {
    const items = await fetchAllPages(async (offset) => {
        const { data } = await client.query({
            query: dmsDocumentFindDraftsQuery,
            variables: {
                input: {
                    companyId,
                    types: [DmsType.ER, DmsType.Bank, DmsType.KB],
                    recordAttached: GQL.IDmsDocumentLinkFilter.NotAttached,
                    // documents linked to a transaction are booked once, through the transaction export
                    bankTransactionAttached: GQL.IDmsDocumentLinkFilter.NotAttached,
                    cashRegisterTransactionAttached: GQL.IDmsDocumentLinkFilter.NotAttached,
                    aiStatus: GQL.IDmsDocumentAiStatusFilter.Success,
                    dateFrom: `${year}-01-01`,
                    dateTo: `${year}-12-31`,
                    limit: MAX_IDS_PER_JOB,
                    offset,
                },
            },
            fetchPolicy: "no-cache",
        });
        return { items: data?.dmsDocumentFind.items ?? [], total: data?.dmsDocumentFind.total ?? 0 };
    }, MAX_IDS_PER_JOB);
    return items.map((i) => ({ id: i.documentId, type: i.type ?? "", subType: i.subType }));
};
